import { useEffect, useState } from 'react'
import { XIcon } from './icons'
import './PrintErrorBanner.css'

/** App'in print'i ağ yazıcısına gönderemeyince attığı olay. */
export const PRINT_FAILED_EVENT = 'adissoo:print-failed'

/**
 * Ağ yazıcısına gitmeyen fiş (20 Eki 2026). Kasiyer görmezse mutfak
 * siparişi hiç duymaz, o yüzden kendiliğinden kaybolmuyor; çarpıyla kapanıyor.
 */
export function PrintErrorBanner() {
  const [lines, setLines] = useState<string[]>([])

  useEffect(() => {
    const on = (e: Event) => {
      const detail = (e as CustomEvent<string[]>).detail ?? []
      setLines((prev) => [...new Set([...prev, ...detail])])
    }
    window.addEventListener(PRINT_FAILED_EVENT, on)
    return () => window.removeEventListener(PRINT_FAILED_EVENT, on)
  }, [])

  if (lines.length === 0) return null
  return (
    <div className="perr" role="alert">
      <div className="perr__body">
        <strong>Fiş basılamadı</strong>
        {lines.map((l) => (
          <span key={l}>{l}</span>
        ))}
        <small>Ayarlar &gt; Yazıcılar'dan yazıcıyı deneyin. Fişi tekrar basmak için siparişten yazdırın.</small>
      </div>
      <button type="button" className="perr__x" onClick={() => setLines([])} aria-label="Kapat">
        <XIcon />
      </button>
    </div>
  )
}
